var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSocialLinkedin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.525,
    height: 20,
    viewBox: "0 0 17.525 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "social_linkedin",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2138",
    "data-name": "Path 2138",
    d: "M2.043,7.333H6V22H2.043Zm12.073,0a4.074,4.074,0,0,0-2.783,1.159V7.333H7.355V22h3.979V12.767s-.145-1.839,2.059-1.839a1.718,1.718,0,0,1,1.941,1.839V22h4.192V12.9A5.127,5.127,0,0,0,14.116,7.335ZM2,4A2,2,0,1,0,4,2,2,2,0,0,0,2,4Z",
    fill: "#0d47a1"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSocialLinkedin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/social_linkedin.b51ea7d77ab4baf3164aec4ff7bf2084.svg";